import { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
} from "reactstrap";
import { useParams, useNavigate } from "react-router-dom";
import usersModel from "models/users.model";
import AddButton from "components/Button/AddButton";
import BackButton from "components/Button/BackButton";

const EditSupportPage = () => {
  const { id } = useParams(); 
  const navigate = useNavigate(); 

  const [supportIssue, setSupportIssue] = useState(null);
  const [status, setStatus] = useState("Open");
  const [message, setMessage] = useState("");

  const getSupportIssue = async () => {
    const res = await usersModel.getSupport(id).then((res) => {
      console.log("Support issue:", res);
      setSupportIssue(res.support[0]);
      setMessage(res.support[0]?.message);
      setStatus(res.support[0]?.status);
    }
    ).catch((err) => {
      console.log(err);
    });
  }

  useEffect(() => {
    
    getSupportIssue();
  }, [id, navigate]);

  // Function to handle support issue update
  const handleUpdateIssue = (e) => {
    e.preventDefault();
    const updatedIssue = {
      ...supportIssue,
      status: status,
      response: message, 
    };

    const res = usersModel.updateSupport(id, updatedIssue).then((res) => {
      console.log("Support issue updated:", res);
      navigate("/admin/support");
    }).catch((err) => {
      console.log(err);
    });

  };

  if (!supportIssue) {
    navigate("/admin/support"); 
  }

  return (
    <Container className="pt-7">
      <Row>
        <div className="col">
          <Card className="shadow">
            <CardHeader className="border-0">
              <h3 className="mb-0">Edit Support Issue</h3>
            </CardHeader>
            <CardBody>
              <Form onSubmit={handleUpdateIssue}>
                <Row>
                  <Col md='4'>
                  <FormGroup>
                  <Label for="username">Username</Label>
                  <Input
                    type="text"
                    id="username"
                    value={supportIssue?.user?.firstName + " " + supportIssue?.user?.lastName}
                    readOnly
                  />
                </FormGroup>
                  </Col>
                  <Col md='4'>
                  <FormGroup>
                  <Label for="mobile">Mobile Number</Label>
                  <Input
                    type="text"
                    id="mobile"
                    value={supportIssue?.user?.mobileNo}
                    readOnly
                  />
                </FormGroup>
                  </Col>

                  <Col md='4'>
                  <FormGroup>
                  <Label for="status">Status</Label>
                  <Input
                    type="select"
                    id="status"
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                  >
                    <option value="Open">Open</option>
                    <option value="In Progress">In Progress</option>
                    <option value="Resolved">Resolved</option>
                  </Input>
                </FormGroup>
                  </Col>
                </Row>
                
                
                <FormGroup>
                  <Label for="subject">Subject</Label>
                  <Input
                    type="text"
                    id="subject"
                    value={supportIssue?.subject}
                    readOnly
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="issue">Issue</Label>
                  <Input
                    type="textarea"
                    id="issue"
                    value={supportIssue?.message}
                    readOnly
                  />
                </FormGroup>
               
                <FormGroup>
                  <Label for="message">Add Message</Label>
                  <Input
                    type="textarea"
                    id="message"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    placeholder="Add your message here"
                  />
                </FormGroup>
                <div className="d-flex justify-content-between align-items-center">
                <BackButton />
                <AddButton title='Save Changes' />
             </div>
              </Form>
            </CardBody>
          </Card>
        </div>
      </Row>
    </Container>
  );
};

export default EditSupportPage;
